import { Link } from "react-router-dom";
import { Linkedin, Twitter, Mail } from "lucide-react";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="border-t border-border bg-card">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block" aria-label="Burgerc_ - Return to homepage">
              <span className="text-xl font-bold tracking-tight">
                Burgerc<span className="text-primary animate-cursor-blink">_</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-muted-foreground max-w-sm">Technical CEO turned coach. 1:1 founder coaching, keynotes, and rapid response for startups navigating growth, crisis, and the lonely parts of leadership.</p>
            <div className="flex gap-4 mt-6">
              <a href="https://linkedin.com/in/bastianburger" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Connect with Bastian Burger on LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="https://twitter.com/bastianburger" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Follow Bastian Burger on Twitter">
                <Twitter size={20} />
              </a>
              <a href="mailto:bastian@burgerconsult.com" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Send email to Bastian Burger">
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services/coaching" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Founder Coaching
                </Link>
              </li>
              <li>
                <Link to="/services/keynotes" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Keynotes
                </Link>
              </li>
              <li>
                <Link to="/services/rapid-response" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Rapid Response
                </Link>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {currentYear} Bastian Burger Consulting. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <Link to="/imprint" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Imprint
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;